export default __webpack_public_path__ + "static/media/img--interiors-2.1f76e58d.jpg";